import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
// create context
export const ModalContext = createContext();
// Create provider
const ModalProvider = (props) => {

    //state del provider 
    const [idRecipe, saveIdRecipe] = useState(null);
    const [information , saveRecipe] = useState({});
    useEffect(() => {
        const consultApi = async () => {
            if (!idRecipe) return;
            const url = `https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i=${idRecipe}`;
            const result = await axios.get(url);
            // console.log(result.data.drinks[0]);
            saveRecipe(result.data.drinks[0]);
        };
        consultApi();
    }, [idRecipe]);

    return (
        <ModalContext.Provider// El valor de todos los tabs se llama value
            value={{
                information,
                saveIdRecipe,
                saveRecipe
            }}
        >
            {props.children}
        </ModalContext.Provider>

    );
}

export default ModalProvider;